import { Outlet } from 'react-router-dom'

export const Createit = () => {
    return(
        <Outlet/>
    )
}